import { Select } from '@nike/eds';
import { FC, useEffect } from 'react';
import { Props as ReactSelectProps } from 'react-select';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { ITransferData } from '../NewTranferInterface';
import { updateInputTouched } from '../../../redux/actions/inputActions';
import { fetchEngineeringTransferType } from '../../../redux/actions/newTransferActions';

interface FieldProps {
  transferData: any | ITransferData;
  setTransferData: (params: any) => any;
}

const EngineeringType: FC<FieldProps> = ({ transferData, setTransferData }) => {
  const [engineeringTransferTypes] = useAppSelector(state => [
    state.newTransfer.engineeringTransferTypes,
  ]);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch<any>(fetchEngineeringTransferType());
  }, []);

  const handleSelectInputChange: ReactSelectProps['onChange'] = (
    value: any
  ) => {
    setTransferData({ ...transferData, engineeringTransferType: value });

    dispatch<any>(updateInputTouched(true));
  };

  return (
    <Select
      isClearable
      options={engineeringTransferTypes}
      id="engineering-trf-type-select"
      label="Engineering Transfer Type"
      name="engineeringTransferType"
      onChange={handleSelectInputChange}
      value={transferData.engineeringTransferType}
      isDisabled={!transferData?.transferType?.value}
    />
  );
};

export default EngineeringType;
